package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * `state defaults { ... }` 块。
 */
data class StateAst(
    val entries: List<StateEntry>,
    override val position: SourcePosition,
) : AstNode {

    /** 单条状态默认值条目。 */
    data class StateEntry(
        val name: String,
        /**
         * 默认值字面量表达式。
         *
         * 类型为 [ExprAst]（M6 review must-fix A）：
         * 除基础字面量（StringLit / NumberLit / BoolLit）外，还允许
         * [ExprAst.NullLit] / [ExprAst.ListLiteralExpr] / [ExprAst.MapLiteralExpr]，
         * 由 [top.wcpe.allincore.dsl.compiler.parse.StateBlockParser] 递归校验保证内层
         * 也仅出现字面量；不允许出现表达式（IdentRef、BinaryOp 等）。
         */
        val literal: ExprAst,
        val position: SourcePosition,
        /**
         * M5-c #I5：可选类型标注。
         *
         * 存在时参与 wire（IR → 1B ordinal）与 runtime 校验；
         * 不存在时等价于 AnyT，写入任意类型皆合法，保持现有 222 个 .allin 资源零破坏。
         */
        val type: TypeAst? = null,
    )
}
